export default function (obj: object, map: (key) => object) {
  return Object.assign({}, ...Object.keys(obj).map(map));
}
